import { useState } from 'react';
import { IImportar } from "../../interfaces/IImportar";
import { Modal } from 'react-bootstrap-v5';
import ImportarNovoModalEmpresa from './ImportarNovoModalEmpresa';
import ImportarNovoModalRegime from './ImportarNovoModalRegime';

const ImportarNovoModal = ({ toggleModal, salvar, show, importar, title }: { toggleModal: () => void, salvar: (importar: IImportar) => void, show: boolean, importar: IImportar, title: string }) => {
 
    const [abaSelecionada, setAbaSelecionada] = useState<any>(1);

    const BotoesHeaderTabela = () => {
        const opcoesFiltros = [
            { id: 1, descricao: 'Cadastro Empresa' },
            { id: 2, descricao: 'Regime tributário' }
        ];

        return <>
            {
                opcoesFiltros.map((x, index) => <button key={index} type="submit"  id={`${x.id}`} className={`btn btn-filtro ${x.id === abaSelecionada && 'ativo'}`} onClick={() => setAbaSelecionada(x.id)}>{x.descricao}</button>)
            }
        </>
    };

    return <Modal size='xl' centered={true} show={show} onHide={toggleModal}>
        <div className="modal-content">
            <div className="modal-header" style={{padding: '10px 15px 5px 35px'}}>
                <h5 className="modal-title titulo-modal">{title}</h5>
                <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                    <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                </div>
            </div>
            <div className="modal-body" style={{padding: '10px'}}>
                <BotoesHeaderTabela />
                {
                    abaSelecionada === 1 ? <ImportarNovoModalEmpresa /> : <ImportarNovoModalRegime />
                }
            </div>
            <div className="modal-footer" style={{ margin: '0 auto' }}>
                <button onClick={toggleModal} type="button" className="btn btn-modal-cancelar me-5"> CANCELAR </button>
                <button onClick={() => {
                    salvar(importar);
                }} type="button" className="btn btn-primario ms-5"> {importar.id ? 'EDITAR' : 'ADICIONAR'} </button>
            </div>
        </div>
    </Modal>
}

export default ImportarNovoModal;